import { InstallmentCalculatorDialog } from '@packages/installment-calculator/src/InstallmentCalculatorDialog/InstallmentCalculatorDialog.client';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useState } from 'react';
import { ComponentTypes } from '../../../interfaces';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import type { CmsInstallmentCalculatorType } from './types';

/**
 * This component shows an installment calculator when clicking on a text link.
 * The user can calculate how he could pay his product in installments.
 *
 * @param data Object contains data
 * @returns JSX.Element to be placed in PageLayout
 */
export const CmsInstallmentCalculator = ({ data }: { data: CmsInstallmentCalculatorType }) => {
  const [dialogOpened, setDialogOpened] = useState(false);
  const { field_link: linkTitle } = data;

  return (
    <>
      {linkTitle && (
        <Button
          className="bg-color-transparent! border-none p-0 underline"
          onClick={() => {
            setDialogOpened(true);
          }}
        >
          {linkTitle}
        </Button>
      )}
      {dialogOpened && (
        <InstallmentCalculatorDialog
          basePrice={10000}
          isOpen={dialogOpened}
          onClose={() => setDialogOpened(false)}
          hasEditablePrice
        />
      )}
    </>
  );
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.InstallmentCalculator]: CmsInstallmentCalculator });
